// PRD 06 §2.1 / §3.5 / PRD 21 §10.5 — Recent deployments card.
//
// The mock + future BE store up to 50 entries; this card renders the latest
// 10. Layout follows the prototype's "최근 배포 이력" card at the bottom of
// the page body.

import { useTranslation } from 'react-i18next';

import { useDeployHistoryQuery } from '../hooks/use-deployment-current-config';
import { formatDeploySummary } from '../utils/format-summary';

export function DeployHistoryCard() {
  const { t } = useTranslation('pro-deployment');
  const historyQuery = useDeployHistoryQuery(10);
  const entries = historyQuery.data ?? [];

  return (
    <div
      className="card"
      style={{
        marginTop: 'var(--space-8)',
        padding: 'var(--space-5) var(--space-6)',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 'var(--space-3)',
        }}
      >
        <h3 style={{ fontSize: 'var(--font-size-base)', fontWeight: 700, margin: 0 }}>
          {t('history.title')}
        </h3>
        <span
          style={{
            fontSize: 'var(--font-size-xs)',
            color: 'var(--muted-foreground)',
          }}
        >
          {t('history.count', { count: entries.length })}
        </span>
      </div>
      {entries.length === 0 ? (
        <div
          style={{
            padding: '32px 0',
            textAlign: 'center',
            color: 'var(--muted-foreground)',
            fontSize: 'var(--font-size-sm)',
          }}
        >
          {t('history.empty')}
        </div>
      ) : (
        <table className="table" style={{ margin: 0, fontSize: 'var(--font-size-sm)' }}>
          <thead>
            <tr>
              <th style={{ width: 180 }}>{t('history.columns.deployedAt')}</th>
              <th style={{ width: 200 }}>{t('history.columns.deployer')}</th>
              {/* FEATURE_025 — PRD 06 v1.21 §2.2 No.12: which layer each deploy published. */}
              <th style={{ width: 200 }}>{t('history.columns.target')}</th>
              <th>{t('history.columns.summary')}</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry, i) => (
              <tr key={`${entry.deployedAt}-${i}`}>
                <td style={{ fontVariantNumeric: 'tabular-nums' }}>{entry.deployedAt}</td>
                <td>
                  {t('history.deployer', {
                    name: entry.deployerName,
                    role: entry.deployerRole,
                  })}
                </td>
                <td>{entry.target || t('history.noTarget')}</td>
                <td>{formatDeploySummary(entry.summary, t)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
